module.exports = __webpack_public_path__ + "img/1563076421.f4d680e8.jpg";